import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { releaseContractPayment } from "../services/goHireService";
import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";

export const useReleaseContractPayment = () => {
  const { t } = useTranslation("goService", { keyPrefix: "createContractPage" });
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (contractId: number) => releaseContractPayment(contractId),
    onSuccess: (_, contractId) => {
      toast.success(t("paymentReleased"));
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.contractDetails(contractId) });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.receivedContracts() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.orderedContracts() });
    },
  });
};
